// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"162":"wide-components","447":"narrow-components","737":"resize-observer-polyfill","992":"reports"}[chunkId] || chunkId) + "." + {"162":"8ded5c13","231":"e37c027b","447":"574c7b46","473":"02c273e8","553":"e06509f6","665":"ae7f6f2a","737":"98a18736","992":"892e778c"}[chunkId] + ".chunk.js";
};